'use client';

/* eslint-disable @next/next/no-img-element */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */

import AssetUploader from 'src/components/modules/AssetManagement/AssetUploader';
import ExistingAssetTable from 'src/components/modules/AssetManagement/ExistingAssetTable';
import Help from 'src/components/modules/AssetManagement/Help';
import Instructions from 'src/components/modules/AssetManagement/Instructions/Instructions';
import styles from './AssetManager.module.scss';


function AssetManager({session}) {

    return (
        <div className={styles.container}>
            <Instructions />

            <AssetUploader session={session} />
            <ExistingAssetTable />

            <Help />
        </div>
    );
}

export default AssetManager;
